export const filters = [
  {
    aggType: "has_reservations_enabled",
    aggValue: "true",
    countryCodes: ["US", "CA"],
    label: "Pickup",
    retailTypes: ["dispensary", "cbd-store"],
    type: "pickup",
  },
  {
    aggType: "flags",
    aggValue: "delivery",
    countryCodes: ["US", "CA"],
    label: "Delivery",
    retailTypes: ["dispensary"],
    type: "delivery",
  },
  {
    aggType: "flags",
    aggValue: "medical",
    countryCodes: ["US", "CA"],
    label: "Medical",
    retailTypes: ["dispensary"],
    type: "medical",
  },
  {
    aggType: "flags",
    aggValue: "recreational",
    countryCodes: ["US", "CA"],
    label: "Recreational",
    retailTypes: ["dispensary"],
    type: "recreational",
  },
  {
    aggType: "flags",
    aggValue: "verifies_medical_cards_247",
    countryCodes: ["US", "CA"],
    label: "24/7 verification",
    retailTypes: ["clinic"],
    type: "verifies_medical_cards_247",
  },
  {
    aggType: "flags",
    aggValue: "atm",
    countryCodes: ["US", "CA"],
    label: "ATM",
    retailTypes: ["dispensary", "cbd-store", "clinic"],
    type: "atm",
  },
  {
    aggType: "flags",
    aggValue: "credit_cards",
    countryCodes: ["US", "CA"],
    label: "Debit cards",
    retailTypes: ["dispensary", "cbd-store", "clinic"],
    type: "credit_cards",
  },
  {
    aggType: "flags",
    aggValue: "offers_medical_cards",
    countryCodes: ["US", "CA"],
    label: "Offers physical cards",
    retailTypes: ["clinic"],
    type: "offers_medical_cards",
  },
  {
    aggType: "flags",
    aggValue: "veteran_discount",
    countryCodes: ["US", "CA"],
    label: "Veteran discount",
    retailTypes: ["dispensary", "cbd-store", "clinic"],
    type: "veteran_discount",
  },
  {
    aggType: "flags",
    aggValue: "clinic_walk_ins_welcome",
    countryCodes: ["US", "CA"],
    label: "Walk-ins welcome",
    retailTypes: ["clinic"],
    type: "clinic_walk_ins_welcome",
  },
  {
    aggType: "flags",
    aggValue: "offers_wallet_sized_medical_cards",
    countryCodes: ["US", "CA"],
    label: "Wallet-sized authorizations",
    retailTypes: ["clinic"],
    type: "offers_wallet_sized_medical_cards",
  },
  {
    aggType: "flags",
    aggValue: "ada",
    countryCodes: ["US", "CA"],
    label: "Wheelchair accessible",
    retailTypes: ["dispensary", "cbd-store", "clinic"],
    type: "ada",
  },
];

export const getLocalizedFilters = (
  countryCode: "US" | "CA",
  retailType: string
) => {
  return filters.filter(
    (f) =>
      f.retailTypes.includes(retailType) && f.countryCodes.includes(countryCode)
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
export const getValidUserFilters = (userFilters: any[]) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  let validFilters: any[] = [];
  if (!userFilters) {
    return validFilters;
  }
  if (Array.isArray(userFilters)) {
    userFilters.forEach((userFilter) => {
      validFilters = [
        ...validFilters,
        ...filters
          .filter((filter) => userFilter === filter.type)
          .map((filter) => filter.type),
      ];
    });
  } else if (typeof userFilters === "string") {
    filters.forEach((filter) => {
      if (filter.type === userFilters) {
        validFilters = [userFilters];
      }
    });
  }

  return validFilters;
};

export const getInitialFilters = (
  countryCode: "US" | "CA",
  retailType: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  query: any = {}
) => {
  const { info, storetype, filter: userFilters } = query;

  let initialFilters = getValidUserFilters(userFilters);

  if (!info && !storetype) {
    return initialFilters;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  const queryFilters: any[] = [].concat(
    info ? info : [],
    storetype ? storetype : []
  );

  const localizedFilters = getLocalizedFilters(countryCode, retailType);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  localizedFilters.forEach((filter: any) => {
    if (queryFilters.includes(filter?.type)) {
      initialFilters = [...initialFilters, filter.type];
    }
  });

  return initialFilters;
};

export const PICKUP_FILTER = "pickup";
export const DELIVERY_FILTER = "delivery";
export const OPEN_NOW_FILTER = "open_now";
export const PRE_ORDER_FILTER = "pre_order";
export const RECREATIONAL_FILTER = "recreational";
export const MEDICAL_FILTER = "medical";
export const HAS_DEALS = "deals";
